import React, {useRef, useEffect, useContext} from 'react';
import ReactDOM from 'react-dom';
import {useUpdateEffect} from 'ahooks';
import useProps from '../use-props';
import Dom from './Dom';

// 将 jsx 的 style 小驼峰的 key 属性，转化为 cssText 的 -
const convertCamelToCSS = (style) => {
    let cssText = '';
    for (let property in style) {
        if (style.hasOwnProperty(property)) {
            let value = style[property];
            if (value && typeof value === 'number' && !isNaN(value)) {
                value = value + 'px';
            }
            let cssProperty = property.replace(/([A-Z])/g, '-$1').toLowerCase();
            cssText += `${cssProperty}: ${value}; `;
        }
    }

    return cssText;
}

export default function (props) {
    const {data, getParentContainer, style, cssText, show = true, avoid = true, children, _registerDomLayer, ...otherProps} = props;
    const {map} = useProps();

    const domRef = useRef(document.createElement('div'));
    const overlay = useRef();
    const unregisterRef = useRef();

    useEffect(() => {
        setStyle(cssText, style);

        overlay.current = new Dom({
            map,
            position: data,
            element: domRef.current,
            positioning: "bottom-center",
            offset: [0, -10],
            ...otherProps
        });

        const parentDom = getParentContainer ? getParentContainer() : map._element;
        parentDom.appendChild(domRef.current);

        // 如果有DomLayer注册函数，则注册此DOM元素
        if (_registerDomLayer) {
            unregisterRef.current = _registerDomLayer(domRef.current, { avoid });
        }

        return () => {
            overlay.current.destroy();

            // 调用注销函数
            if (unregisterRef.current) {
                unregisterRef.current();
            }

            parentDom.removeChild(domRef.current);
        }
    }, []);

    useUpdateEffect(() => {
        setStyle(cssText, style);
    }, [cssText, JSON.stringify(style)]);

    useUpdateEffect(() => {
        overlay.current.setPosition(data)
    }, [JSON.stringify(data)])

    useUpdateEffect(() => {
        domRef.current.style.display = show ? 'block' : 'none';
    }, [show])

    const setStyle = (_cssText, _style) => {
        let cssText = domRef.current?.style?.cssText || `
            display: ${show ? 'block' : 'none'};
            position: absolute;
            user-select: none;
            pointer-events: none;
        `;

        // 兼容css未加;
        if (_cssText) {
            const lastStr = _cssText[_cssText.length - 1];
            if (lastStr !== ';') {
                _cssText = `${_cssText}; `
            }

            cssText = `
                ${cssText}
                ${_cssText}
            `
        }

        if (_style) {
            // 转换为CSS文本
            const styleToCss = convertCamelToCSS(_style);
            cssText = `
                ${cssText}
                ${styleToCss}
            `
        }

        domRef.current.style.cssText = cssText;
    }

    return ReactDOM.createPortal(
        children,
        domRef.current
    );
}
